import { atom } from "jotai";

/**
 * The push-to-talk scope (composer) the user last focused. It owns the key
 * while focus is outside every text field. See `usePushToTalkScope`.
 */
export const lastFocusedPushToTalkScopeAtom = atom<string | null>(null);
